<template>
	<dms-wrapper :label="labelText" v-bind="{span, wrapp, validationRules, noLabelAlign}" :validation-property="validationPropertyCmp" :disabled="isDisabled">
		<el-row type="flex">
			<div class="frm-inp-group">
				<slot />
			</div>
			<dms-button-group>
				<dms-info-button :text="text" :title-key="titleKey" :type="type" :disabled="buttonDisabled" />
			</dms-button-group>
		</el-row>
	</dms-wrapper>
</template>

<script>
import { BaseInput } from '#components/dms/common/baseInput';
import DmsWrapper from '#components/dms/form/Wrapper.vue';
import { BUTTON_TYPES, BUTTON_TYPES_ENUM } from '#components/@types/button';

export default BaseInput.extend({
	name: 'DmsInfoInput',
	components: { DmsWrapper },
	props: {
		buttonDisabled: { type: Boolean, default: false },
		text: { type: String, default: '' },
		type: {
			type: String,
			in: BUTTON_TYPES,
			default: BUTTON_TYPES_ENUM.INFO,
		},
		noLabelAlign: { type: Boolean, default: false },
	},
});
</script>

<style lang="scss" scoped>
::v-deep .info-button:not(.is-disabled) {
	background-color: $color-info;
	border-color: $color-info;
	&:hover {
		background-color: $color-info-hover;
		border-color: $color-info-hover;
	}
}
::v-deep .info-button {
	color: white;
	margin-left: 0;
}
::v-deep .dialog__footer--buttons .el-button {
	min-width: 80px;
}
.frm-inp-group {
	flex-grow: 1;
	::v-deep .el-col input.el-input__inner {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
	}
	::v-deep .frm-group {
		margin-bottom: 0;
	}
}
::v-deep .el-button-group button:first-child {
	border-top-left-radius: 0;
	border-bottom-left-radius: 0;
}
</style>
